export function loadBMap(funcName) {
  var script = document.createElement("script");
  script.src = "https://api.map.baidu.com/api?type=webgl&v=2.0&ak=BhWPi15PGfcZxDSQR7AfHcYf8qh6vxaq&callback=" + funcName;
  // script.src = "http://api.map.baidu.com/api?v=2.0&ak=4SohswS24sY2IWAiMmntfpR398zEXjVm&callback=" + funcName;
  document.body.appendChild(script);
}